import { useMutation, useQuery } from '@apollo/client';

import { gql } from 'src/__generated__';
import type { Skill } from 'src/__generated__/graphql';
import { logError } from 'src/modules/error-logger/browserLog';

const UPDATE_MUTATION = gql(`
  mutation UpdateSkills($skillsData: UpdateSkillsInput!) {
    updateSkills(input: $skillsData) {
      viewer {
        _id
        skills {
          keyword {
            text
            ontologyId
          }
        }
      }
    }
  }
`);

const SKILLS_QUERY = gql(`
  query GetSkills {
    viewer {
      _id
      skills {
        keyword {
          text
          ontologyId
        }
      }
    }
  }
`);

export function useSkills() {
  const { data } = useQuery(SKILLS_QUERY);
  const [update, { error }] = useMutation(UPDATE_MUTATION);

  const updateSkills = async (skills: Skill[]) => {
    try {
      await update({ variables: { skillsData: { skills } } });
    } catch (err: any) {
      logError({ ...err, type: 'update-skills' }, { error: err });
      throw err;
    }
  };

  return { updateSkills, skills: data?.viewer?.skills || [], error };
}
